module.exports = __webpack_public_path__ + "img/image-02.78880e95.jpeg";